import React from 'react';

import WordExportButton from '../../../features/template-workspace/word-export/WordExportButton';

/**
 * Блок для ввода и управления текстом рекомендаций для пациента.
 * Позволяет редактировать, очищать и экспортировать рекомендации.
 *
 * Пропсы:
 *  - recommendationsText: string — текст рекомендаций
 *  - setRecommendationsText: function — обработчик изменения текста
 *  - exportToWord: function — обработчик экспорта в Word
 *  - isExportDisabled: boolean — признак выполняющегося Word-экспорта
 */
const RecommendationsBlock = ({
  recommendationsText,
  setRecommendationsText,
  exportToWord,
  isExportDisabled,
}) => (
  <div className="template-block" style={{ paddingLeft: 10, marginTop: 0 }}>
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginRight: 0 }}>
      <button
        className="move-arrow-btn"
        disabled
        style={{ marginBottom: 2 }}
        title="Переместить вверх"
      >
        ▲
      </button>
      <button
        className="move-arrow-btn"
        disabled
        title="Переместить вниз"
      >
        ▼
      </button>
    </div>
    <div className="zone-description" style={{ flexBasis: '10%', width: 140, minWidth: 140, maxWidth: 140, fontSize: '0.9rem' }}>
      РЕКОМЕНДАЦИИ
    </div>
    <div className="block-text" style={{ flex: 1 }}>
      <textarea
        value={recommendationsText}
        onChange={e => setRecommendationsText(e.target.value)}
        placeholder="Введите текст"
        style={{ width: '100%', minHeight: 100, fontSize: 15, borderRadius: 8, border: '1px solid #ccd1d9', background: '#f4f6f8', color: '#2c3e50', padding: 8, resize: 'vertical', boxSizing: 'border-box' }}
      />
      <div className="block-controls">
        <button
          onClick={() => setRecommendationsText('')}
          style={{
            width: 32,
            height: 32,
            minWidth: 32,
            minHeight: 32,
            maxWidth: 32,
            maxHeight: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            padding: 0
          }}
        >
          🧹
        </button>
        <WordExportButton
          className="main-action-btn word"
          disabled={isExportDisabled}
          onClick={exportToWord}
          style={{ marginRight: '0px', height: 32 }}
        >
          📄 Выгрузить в Word
        </WordExportButton>
      </div>
    </div>
  </div>
);

export default RecommendationsBlock;
